'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertData = exports.buildEvents = undefined;

var _ajax = require('./ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _lodashCompat = require('lodash-compat');

var _data = require('../../util/data');

var _promisify = require('../../util/func/promisify');

var _promisify2 = _interopRequireDefault(_promisify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 精简bill的功能
 * @param model
 * @returns {Function}
 */
var buildEvents = function buildEvents(model) {
  var factory = {};
  var eventMap = {
    'bind': 'onBind',
    'bindNode': 'onBindNode'
  };
  var searchFields = {};
  if ((0, _lodashCompat.isArray)(model.events)) {
    (model.fields || []).forEach(function (f) {
      searchFields[f.code] = f;
    });
    model.events.forEach(function (e) {
      if (e) {
        if (!factory[e.code]) {
          factory[e.code] = {};
        }
        // 现在仅处理bind和bindNode事件
        if (['bind', 'bindNode'].includes(e.type)) {
          var evType = e.type;
          if (searchFields[e.code] && searchFields[e.code][eventMap[evType]]) {
            // 请求方式同时支持callback和promise
            factory[e.code][evType] = (0, _promisify2.default)(searchFields[e.code][eventMap[evType]]);
          } else {
            (function () {
              //FIXME 是否支持自定义params
              var params = {};
              factory[e.code][evType] = function (code, callback) {
                return new Promise(function ($return, $error) {
                  return Promise.resolve((0, _ajax2.default)(e.url, params)).then(function ($await_1) {
                    var data = $await_1;
                    data = (0, _lodashCompat.isArray)(data) ? data : (0, _lodashCompat.isArray)(data.pageList) ? data.pageList : [];
                    callback && callback(data);
                    return $return(data);
                  }.$asyncbind(this, $error), $error);
                }.$asyncbind(this));
              };
            })();
          }
        }
      }
    });
  }
  return function (code, type, bill) {
    var handler = void 0;
    if (factory[code] && factory[code][type]) {
      handler = factory[code][type];
    } else if (searchFields[code][eventMap[type]]) {
      handler = (0, _promisify2.default)(searchFields[code][eventMap[type]]);
    }
    return typeof handler === 'function' ? bill ? handler.bind(handler, bill, type) : handler.bind(handler, type) : null;
  };
};

/**
 * 搜索条件的数据格式转换
 * @param data
 * @param model
 */
var convertData = function convertData(data, model) {
  if ((0, _data.isEmptyString)(data)) return undefined;
  var code = model.code;
  var showCode = model.showCode;
  var fieldType = model.type;
  var m = model.model;
  var filterType = model.filterType;

  var idField = m && m.idField || 'value';
  var showField = m && m.showField || 'label';

  //表头筛选的类型优先级大于字段类型
  var type = filterType || fieldType;
  switch (type) {
    case 'select':
    case 'treeSelect':
      return Object.assign(_defineProperty({}, code, (0, _lodashCompat.isObject)(data) ? data[idField] : data), showCode && _defineProperty({}, showCode, data[showField]));
    case 'checkbox':
    case 'multiSelect':
    case 'multiTreeSelect':
      //FIXME 返回idField的集合，会不会有可能需要其他字段
      return _defineProperty({}, code, (0, _lodashCompat.isArray)(data) ? data.map(function (d) {
        return (0, _lodashCompat.isObject)(d) ? d[idField] : d;
      }) : (0, _lodashCompat.isObject)(data) ? data[idField] : []);
    case 'radio':
      return _defineProperty({}, code, data[idField]);

    default:
      return _defineProperty({}, code, data);
  }
};

exports.buildEvents = buildEvents;
exports.convertData = convertData;